import axios from "axios";

export default {
    actions: {
        async fetchProductUniqueTypes(ctx) {
            // if (Object.keys(ctx.state.productTypeCodes).length > 0) return new Promise().then(resolve=>resolve);
            return await axios.get('/api/product2/units')
                .then(function (response) {
                    if (response.data.status) {
                        const uniqueTypeCodes = response.data.result;
                        ctx.commit("updateCatalogLinks", { uniqueTypeCodes });
                        return response;
                    }
                });
        },
    },

    mutations: {
        updateCatalogLinks(state, { uniqueTypeCodes }) {
            state.productTypeCodes = uniqueTypeCodes;
        }
    },

    state() {
        return {
            productTypeCodes: {}
        };
    },

    getters: {
        getProductTypeCodes(state) {
            return state.productTypeCodes;
        }
    }
};
